import {
  SET_SLOTS,
  RESET_SLOTS,
  UPDATE_SLOT,
  SET_SLOT_PRODUCTS,
  RESET_SLOT_PRODUCTS,
  ASSIGN_PRODUCTS_TO_SLOT,
  REMOVE_PRODUCT_FROM_SLOT,
  SET_PRODUCTS_FOR_SLOTS,
} from "../Types/SlotTypes";

const initialState = {
  slots: [],
  slotProducts: {},
  productsForSlots: [],
};

const SlotReducer = (state = initialState, action) => {
  if (action.type === SET_SLOTS) {
    return { ...state, slots: action.payLoad };
  } else if (action.type === RESET_SLOTS) {
    return { ...state, slots: [] };
  } else if (action.type === UPDATE_SLOT) {
    const updatedSlots = state.slots.map(slot =>
      slot.id === action.payLoad.id ? { ...slot, ...action.payLoad } : slot
    );
    return { ...state, slots: updatedSlots };
  } else if (action.type === SET_SLOT_PRODUCTS) {
    return {
      ...state,
      slotProducts: {
        ...state.slotProducts,
        [action.payLoad.slotId]: action.payLoad.products
      }
    };
  } else if (action.type === RESET_SLOT_PRODUCTS) {
    return { ...state, slotProducts: {} };
  } else if (action.type === ASSIGN_PRODUCTS_TO_SLOT) {
    const { slotId, productIds } = action.payLoad;
    const updatedSlots = state.slots.map(slot => {
      if (slot.id === slotId) {
        // Add new products to the slot's products array
        const existingProductIds = slot.products?.map(p => p.id) || [];
        const newProducts = state.productsForSlots.filter(p =>
          productIds.includes(p.id) && !existingProductIds.includes(p.id)
        );
        return {
          ...slot,
          products: [...(slot.products || []), ...newProducts]
        };
      }
      return slot;
    });
    return { ...state, slots: updatedSlots };
  } else if (action.type === REMOVE_PRODUCT_FROM_SLOT) {
    const { slotId, productId } = action.payLoad;
    const updatedSlots = state.slots.map(slot => {
      if (slot.id === slotId) {
        return {
          ...slot,
          products: (slot.products || []).filter(p => p.id !== productId)
        };
      }
      return slot;
    });
    return { ...state, slots: updatedSlots };
  } else if (action.type === SET_PRODUCTS_FOR_SLOTS) {
    return { ...state, productsForSlots: action.payLoad };
  } else {
    return state;
  }
};

export default SlotReducer;